import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function Dismenu() {
    const [username, setUsername] = useState("Guest");
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsubscribe();
    }, []);

    // Fetch user role & propertyId
    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                if (!userData) return;

                const userRef = doc(db, "authroles", userData.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const user = userSnap.data();
                    setUsername(user.name || "Guest");
                }

            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, [userData]);


    const firstLetter = username.charAt(0).toUpperCase();

    return (
        <aside
            className="main-sidebar"
            style={{
                background: "linear-gradient(180deg, #2a0845 0%, #6441A5 50%, #2a0845 100%)",
                backgroundImage: "url('/back.jpg')",
                backgroundBlendMode: "overlay",
                backgroundSize: "cover",
                color: "#fff",
                minHeight: "100vh",
                boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
            }}
        >
            {/* User Section */}
            <div
                style={{
                    textAlign: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                    padding: "15px 10px",
                }}
            >
                <div
                    style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "28px",
                        fontWeight: "700",
                        margin: "0 auto 10px auto",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                    }}
                >
                    {firstLetter}
                </div>

                <h5 style={{ fontWeight: "600" }}>{username}</h5>


            </div>


        </aside>
    );
}

export default Dismenu;
